<template>
	<div class="profile-wrapper">
		<div class="title">身份切换</div>
		<el-row class="select-wrapper" :gutter="40">
		  <el-col :span="12">
			<el-image @click="changePage('F')" :src="showPage=='F'?require('@/assets/release-select.png'):require('@/assets/release.png')"></el-image> 
			<div class="image-tip">我是需求方</div>
		  </el-col>
		  <el-col :span="12">
			<el-image @click="changePage('J')" :src="showPage=='J'?require('@/assets/receive-select.png'):require('@/assets/receive.png')"></el-image>
			<div class="image-tip">我是接包方</div>
		  </el-col>
		</el-row>
		<div class="btn">
			<el-button type="warning" size="medium" class="submit" @click="updateCrowd">确认切换</el-button>
		</div>
	</div>
</template>

<script>
import { getUsercrowd, updateUsercrowd } from '@/api/personal/index'
export default {
  data () {
    return {
      showPage:'F'
    }
  },
  methods: {
    changePage(role){
		this.showPage = role
	},
	async getCrowd(){
		const res = await getUsercrowd()
		if (res.code === 0) {
			this.showPage = res.data.showPage
		} else {
		  this.$message.error(res.msg)
		}
	},
	async updateCrowd(){
		const res = await updateUsercrowd({showPage:this.showPage})
		if (res.code === 0) {
			this.$message.success('切换成功')
		} else {
		  this.$message.error(res.msg)
		}
	}
  },
  mounted () {
	this.getCrowd()  
  }

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px;
	.title{
		font-size: 20px;
		font-weight: 800;
	}
	.select-wrapper{
		margin: 50px 0;
		.el-col{
			position: relative;
			cursor: pointer;
		}
		.image-tip{
			font-size: 14px;
			color: #303030;
			position: absolute;
			text-align: center;
			bottom: 40px;
			left: 50%;
			margin-left: -40px;
		}
	}
	.btn{
		text-align: center;
	}
	.submit{
		background-color: #FF842E;
		border-radius: 5px;
		width: 120px;
		margin: 20px 0;
	}
}	

</style>